import React, { useRef } from "react";
import localeText from "../../../../locale";
import { FileUpload } from "primereact/fileupload";

const fiveMB = 5 * 1024 * 1024; // 5 MB

const BannerUpload = ({ images, setImages, title }) => {
  const fileUploadRef = useRef(null);

  const handleSelect = (e) => {
    const files = e.files;
    setImages(files);

    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }
  };

  const renderImageName = () => {
    if (!images) return false;

    if (typeof images === "string") return true;

    return images?.length > 0;
  };

  const imageName = () => {
    if (!images) return "";

    if (typeof images === "string") return `${localeText("file")}: ${images}`;

    return `${localeText("file")}: ${images[0]?.name}`;
  };

  return (
    <div className="bannerContainer">
      <p>{localeText(title)}</p>

      <FileUpload
        ref={fileUploadRef}
        mode="basic"
        accept="image/*"
        maxFileSize={fiveMB}
        onSelect={handleSelect}
        customUpload
        uploadHandler={() => {}}
      />

      {renderImageName() && <p className="mt-2 text-xs">{imageName()}</p>}
    </div>
  );
};

export default BannerUpload;
